import { render, staticRenderFns } from "./VulnerabilityTable.vue?vue&type=template&id=94f018da&"
import script from "./VulnerabilityTable.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports